import { Player } from "@lottiefiles/react-lottie-player";
import { useAnimatedBird } from "./animated-bird.provider";
import { useEffect, useRef } from "react";

const AnimatedBird = () => {
  const { top, right, updateBirdPosition } = useAnimatedBird();

  const playerRef = useRef(null);

  useEffect(() => {
    updateBirdPosition(30, 3);
  }, []);

  useEffect(() => {
    if (playerRef.current && top !== undefined && right !== undefined) {
      (playerRef.current as any).container.style.top = `${top}px`;
      (playerRef.current as any).container.style.right = `${right}px`;
    }
  }, [top, right]);

  return (
    <Player
      autoplay
      loop
      ref={playerRef}
      src="lottie/logo.json"
      style={{
        position: "absolute",
        height: "65px",
        width: "65px",
        zIndex: 9999,
      }}
    ></Player>
  );
};

export default AnimatedBird;
